
$(document).ready(function() {
	var elements = $('[data-ctl="autocompleter"]');
	initAutocompleter(elements);
});

function initAutocompleter(elements) {
	$.each(elements, function(index, el) {
		var field = $(el);
        if (!field.is('.init')) {
            field.addClass('init');
            var container = $('<div class="input-group autocompleter-container" style="position:inherit;"></div>');
            var groupAppend = field.next('.input-group-append');
            field.wrap(container);
            container = field.parent('div');
            var manualsearch = field.attr('data-manualsearch') === 'true';
            var forcesearch = false;
            var minLength = field.attr('data-minlength') || 2;
            var displayEl = field.clone();
            displayEl.attr('id', displayEl.attr('id') + 'display' + Math.ceil(Math.random() * 200))
                .attr('name', '')
                .attr('data-val', field.attr('fullvalue'))
                .val(field.attr('fullvalue'));
            field.addClass('d-none').after(displayEl);
            if (manualsearch) {
                displayEl.on('keyup', function (ev) {
                    if (ev.keyCode === $.ui.keyCode.ENTER) {
                        forcesearch = true;
                        displayEl.autocomplete('search');
                        return false;
                    }
                });
            }
            if (field.attr('data-autosearch') === 'true') {
                minLength = 0;
                displayEl.on('focus', function (ev) {
                    forcesearch = !displayEl.is('[data-had-focus]');
                    displayEl.attr('data-had-focus', '');
                    displayEl.autocomplete('search');
                });
            }
            if (field.attr('data-autoexpand') === 'true') {
                displayEl.on('blur', function (ev) {
                    field.val(displayEl.val());
                });
            }
            displayEl.focus(function() {
                if (displayEl.val() !== "" && displayEl.attr('data-val') === '') {
                    displayEl.autocomplete('search');
                }
            });
            $('<div class="input-group-prepend loader-indicator"><span class="input-group-text"><i class="fa fa-search"></i><i class="fa fa-spinner fa-spin"></i></span></div>').insertAfter(field);
            displayEl.autocomplete({
                minLength: minLength,
                position: { collision: 'flip' },
                search: function () {
                    if (manualsearch) {
                        if (!forcesearch) return false;
                        forcesearch = false;
                    }
                },
                source: function (request, response) {
                    var postData = { search: request.term };
                    if (field.is('[data-autocompleter-param]')) {
                        $.each(field.attr('data-autocompleter-param').split(","), function(i, el) {
                            var ctl = $(el.trim());
                            if (ctl.length === 1) {
                                postData[ctl.attr('name')] = ctl.val();
                            }
                        });
                    }
                    if (forcesearch || request.term !== field.attr('data-query')) {
                        field.attr('data-query', request.term);
                        forcesearch = false;
                        $.ajax({
                            url: field.data('url'),
                            dataType: "json",
                            timeout: connection.defaultTimeout,
                            data: postData,
                            beforeSend: function () {
                                field.triggerHandler('beforeSend');
                                container.addClass('autocompleter-loading');
                            },
                            success: function (data) {
                                var cancel = (field.triggerHandler('loaded', {data: data}));
                                // console.log(cancel);
                                // console.log(data);
                                if (cancel !== false) {
                                    response($.map(data, function (item) {
                                        return {
                                            value: item.value,
                                            label: item.label,
                                            icon: item.icon,
                                            hint: item.hint,
                                            item: item,
                                        }
                                    }));
                                }
                            },
                            complete: function () {
                                container.removeClass('autocompleter-loading');
                            }
                        });
                    }
                },
                select: function (event, ui) {
                    if (ui.item.value == null) return;

                    field.val(ui.item.value);
                    displayEl.val(ui.item.item.selectLabel || ui.item.label);
                    field.trigger('changed', {
                        value: ui.item.value,
                        label: ui.item.label,
                        icon: ui.item.icon,
                        field: displayEl,
                        item: ui.item.item,
                    });
                    displayEl.trigger('blur');
                    return false;
                }
            })
            .data('ui-autocomplete')._renderItem = function (ul, item) {
                $(ul).removeClass('ui-autocomplete').addClass('dd-options ctl-autocompleter-options');
                var hint = (item.hint !== undefined) ? ' <span class="hint">' + item.hint + '</span>' : '';
                return $('<li'+(item.disabled ? ' disabled="disabled"' : '')+'>')
                    .append('<a class="dd-option"'+(item.disabled ? ' disabled="disabled"' : '')+'>' + (item.icon || '') + item.label + hint + '</a>')
                    .appendTo(ul);
            };
            displayEl.autocomplete().data('ui-autocomplete')._renderMenu = function (ul, items) {
                var that = this;
                if (field.attr('data-autoexpand') === 'true') {
                    // that._renderItemData(ul, {
                    //     hint: "",
                    //     disabled: true,
                    //     label: field.attr('data-autoexpand-label') || "Eintrag wählen oder neuen Erfassen",
                    //     value: null,
                    // });
                }
                $.each(items, function (index, item) {
                    that._renderItemData(ul, item);
                });
                ul.addClass(field.data('menuclass')).css({'display': 'inline-block', 'max-height': 300});
                if (items.length === 1 && items[0].value === null) {
                    $(field).trigger('no-items-found', { listEl: ul });
                }
            };
            if (groupAppend.length > 0) {
                groupAppend.appendTo(field.parent());
            }
        }
	});
}

window.initAutocompleter = initAutocompleter;
